import { render, staticRenderFns } from "./SupportChatComponent.vue?vue&type=template&id=12339990&"
import script from "./SupportChatComponent.vue?vue&type=script&lang=js&"
export * from "./SupportChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./SupportChatComponent.vue?vue&type=style&index=0&id=12339990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports